import { featureToggleMixin } from "@/mixins";
import mixins from "vue-typed-mixins";
import { mapActions } from "vuex";
import requestPasswordMixin from "./requestPasswordMixin";
const Card = () => import("@/components/composite/Card/Card.vue");
const Button = () => import("@/components/Button.vue");
const Alert = () => import("@/components/Alert.vue");
const Hyperlink = () => import("@/components/Hyperlink.vue");
const ModalForgotPassword = () => import("./ModalForgotPassword.vue");
const CardActivateAccount = () => import("./CardActivateAccount.vue");
const CardProductList = () => import("./CardProductList.vue");
const CardAccountStatus = () => import("./CardAccountStatus.vue");
const CardAccessAccount = () => import("./CardAccessAccount.vue");
export default mixins(featureToggleMixin, requestPasswordMixin).extend({
    components: {
        Card,
        Button,
        Alert,
        Hyperlink,
        ModalForgotPassword,
        CardActivateAccount,
        CardProductList,
        CardAccountStatus,
        CardAccessAccount,
    },
    data: () => ({
        dialogForgotPassword: false,
    }),
    methods: {
        ...mapActions("accountLookup", ["lookup", "requestPassword"]),
        openModalForgotPassword() {
            this.dialogForgotPassword = true;
        },
        onEmailChanged() {
            this.$emit("email:change");
        },
    },
});
